import styled from 'styled-components';
import {
  FormControl,
  IconButton as MuiIconButton,
  Chip as MuiChip,
  Button as MuiButton,
  Card
} from '@mui/material';

export const Box = styled(Card)`
  position: relative;
  width: 100%;
  margin-top: 10px;
  overglow: hidden;
  height: ${props => (props.open ? '300px' : '0px')};
  padding: ${props => (props.open ? '10px' : '0px')};
  opacity: ${props => (props.open ? '1' : '0')};
  transition: all 0.5s;
`;

export const Content = styled.div`
  width: 100%;
  padding: 10px;
`;

export const Form = styled(FormControl)`
  width: 100%;
`;

export const Header = styled.div`
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
`;

export const Bottom = styled.div`
  margin-top: 20px;
  text-align: right;
`;

export const IconButton = styled(MuiIconButton)`
  position: absolute !important;
  right: 10px;
  top: 10px;
`;

export const Chip = styled(MuiChip)`
  margin-right: 10px;
`;

export const Button = styled(MuiButton)`
  margin-left: 5px !important;
  float: ${props => (props.float ? props.float : 'right')};
`;

export const FormTextFieldContainer = styled.div`
  flexgrow: 1;
`;
